import React, { useEffect, useState } from "react";
import InputSelectWithTopLable from "../../../../../../newComponent/themeprovider/textField/InputSelectWithTopLable";
import { Backdrop, Button, CircularProgress, Grid, Stack, ThemeProvider, Typography } from "@mui/material";
import mainTheme from "../../../../../../newComponent/themeprovider/mainTheme/MainTheme";
import { getTrainerByTestType } from "../../../../../../../services/getTrainerByTestType";
import { getClassByTrainer } from "../../../../../../../services/getClassByTrainer";
import { transferStudent } from "../../services/transferStudent";
import { useSnackbar } from "../../../../../../components/ui-component/snackbar/SnackbarContext";

export default function TransferStudentForm({ selectedRowData }) {

  const userId = localStorage.getItem("userId");
  const [trainerList, setTrainerList] = useState([]);
  const [trainerId, setTrainerId] = useState("");
  const [classList, setClassList] = useState([]);
  const [classId, setClassId] = useState("");
  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackbar();

  // fetch trainers
  const handleFetchTrainers = async () => {
    const requestData = {
      user_id: parseInt(userId),
      test_type_id: selectedRowData?.test_type_id?.id ,
    };
    try {
      const response = await getTrainerByTestType(requestData);

      if (response.status === 200) {
        setTrainerList(response.data);
      } else {
        setTrainerList([]);
      }
    } catch (error) {
      console.error("Error fetching trainers:", error);
      setTrainerList([]);
    }
  };

  useEffect(() => {
    handleFetchTrainers();
  }, [selectedRowData]);

  // fetch classes
  useEffect(() => {
    const requestData ={
      trainer_id :trainerId,
      test_type_id :selectedRowData?.test_type_id?.id
    }
    const fetchClasses = async () => {
      try {
        const response = await getClassByTrainer(requestData);
        if (response.status === 200) {
          setClassList(response?.data);
        } else {
          setClassList([]);
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
        setClassList([]);
      }
    };

    if (trainerId) {
      fetchClasses();
    }
  }, [trainerId,selectedRowData?.test_type_id?.id]);

  // transfer student

  const handleTransferStudent = async () => {
    if (!trainerId) {
      showSnackbar("Please select trainer", "error");
      return;
    }

    if (!classId) {
      showSnackbar("Please select class", "error");
      return;
    }

    const requestData = {
      user_id: parseInt(userId),
      std_class_detail_id: selectedRowData?.id,
      enquiry_id: selectedRowData?.enquiry_id?.id,
      new_class_id: classId,
    };
setLoading(true);
    try {
      const response = await transferStudent(requestData);
      if (response.status === 200) {
        showSnackbar("Student transfered successfully", "success");
        setLoading(false);
      } else {
        showSnackbar(response.message || "Failed to transfer student", "error");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      showSnackbar("Failed to transfer student", "error");
      setLoading(false);
    }
  };

  return (
    <>
    <Backdrop open={loading} style={{ zIndex: 9999 }}>
       
          <Typography
            variant="h4"
            color="secondary"
            fontWeight={800}
            marginRight={2}
          >
            Transferring student...
          </Typography>
          <CircularProgress color="secondary" />
      
      </Backdrop>
      <ThemeProvider theme={mainTheme}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputSelectWithTopLable
              label="Trainer Name"
              name="trainer_id"
              textVariant="body2"
              value={trainerId}
              onChange={(e) => setTrainerId(e.target.value)}
              options={trainerList}
              getOptionLabel={(option) =>
                ` ${option.first_name ? option.first_name : ""} ${option.last_name ? option.last_name : ""}`
              }
              getOptionValue={(option) => option.id}
            />
          </Grid>

          {trainerId && (
            <Grid item xs={12}>
              <InputSelectWithTopLable
                label="Class Name"
                name="class_id"
                textVariant="body2"
                value={classId}
                onChange={(e) => setClassId(e.target.value)}
              options={
    classList && classList.length > 0
      ? classList
      : [{ id: "", name: "No class available, please select another trainer" }]
  }
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
              />
            </Grid>
          )}

          <Grid item xs={12} textAlign="right">
            <Button
              size="small"
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              onClick={handleTransferStudent}
            >
              Transfer
            </Button>
          </Grid>
        </Grid>
      </ThemeProvider>
    </>
  );
}
